import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets//images/headerIcon01.png'


const _withScopeId = n => (_pushScopeId("data-v-9e7aa77c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "nav" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, "香草终端", -1))
const _hoisted_5 = { class: "userInfo" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", null, "风格")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "蓝色", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "红色", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "黑色", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("退出")

import { reactive,onMounted } from "vue"
import { useRouter } from "vue-router";
import { queryUserInfo } from "../api/api"

import {useStore} from 'vuex'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const store= useStore()

let obj = reactive({
  userInfo: '',
  navList: [
    // {name: '资产',path: '/PropertyView'},
    {name: '询价管理',path: '/HomeView'},
    {name: '询价记录',path: '/ManageView'},
    {name: '持仓列表',path: '/HoldList'},
    {name: '历史持仓',path: '/HistoryList'},
    {name: '算法服务',path: '/AlgorithmView'},
  ],
})

function goto(path){  // 切换菜单栏
  router.push({
    path: path
  });
}

onMounted(() => {
  if(window.sessionStorage.getItem('token')){
    toQueryUserInfo(window.sessionStorage.getItem('token'))
  }
})
 // 请求 代理用户 信息接口
function toQueryUserInfo(token){
    queryUserInfo({token: token}).then(data=>{
        // console.log('用户信息',data);
        if(data.data.code == 200){
            obj.userInfo = data.data.data;
            window.sessionStorage.setItem('userInfo',JSON.stringify(data.data.data))
        }
    })
}

function logout(){
  // 清空token
  window.sessionStorage.clear()
  store.commit('clearToken')
  // 跳转到登录页
  router.push('/LoginView')

}

/* 全局修改网站颜色风格--定义 */
function changeStyle(style){
  // console.log(style);
  if(style == 'blue'){
    document.documentElement.style.setProperty("--main_color", '#5051F9');
    document.documentElement.style.setProperty("--bg_color", '#F7F7F9');
    document.documentElement.style.setProperty("--bg2_color", '#FFFFFF');
    document.documentElement.style.setProperty("--active_color", '#FFFFFF');
    document.documentElement.style.setProperty("--button_color", '#5051F9');
    document.documentElement.style.setProperty("--font_color1", '#333333');
    document.documentElement.style.setProperty("--font_color2", '#333333');
    document.documentElement.style.setProperty("--buttonBg_color", '#FFFFFF');
    document.documentElement.style.setProperty("--buttonBorder_color", '#EAEAEB');
    document.documentElement.style.setProperty("--table_color1", '#F2F2F2');
    document.documentElement.style.setProperty("--table_color2", '#FFFFFF');
    document.documentElement.style.setProperty("--table_color3", '#F2F2F2');
    document.documentElement.style.setProperty("--table_color4", '#FFFFFF');
    document.documentElement.style.setProperty("--table_font_color1", '#7889A0');
    document.documentElement.style.setProperty("--table_font_color2", '#333333');
    document.documentElement.style.setProperty("--table_font_color3", '#7889A0');
    document.documentElement.style.setProperty("--table_font_color4", '#333333');
    document.documentElement.style.setProperty("--table_bg_color", '#F8FCFF');
  }else if(style == 'red'){
    document.documentElement.style.setProperty("--main_color", '#E6322E');
    document.documentElement.style.setProperty("--bg_color", '#F7F7F9');
    document.documentElement.style.setProperty("--bg2_color", '#FFFFFF');
    document.documentElement.style.setProperty("--active_color", '#FFFFFF');
    document.documentElement.style.setProperty("--button_color", '#E6322E');
    document.documentElement.style.setProperty("--font_color1", '#333333');
    document.documentElement.style.setProperty("--font_color2", '#333333');
    document.documentElement.style.setProperty("--buttonBg_color", '#FFFFFF');
    document.documentElement.style.setProperty("--buttonBorder_color", '#EAEAEB');
    document.documentElement.style.setProperty("--table_color1", '#F2F2F2');
    document.documentElement.style.setProperty("--table_color2", '#FFFFFF');
    document.documentElement.style.setProperty("--table_color3", '#F2F2F2');
    document.documentElement.style.setProperty("--table_color4", '#FFFFFF');
    document.documentElement.style.setProperty("--table_font_color1", '#7889A0');
    document.documentElement.style.setProperty("--table_font_color2", '#333333');
    document.documentElement.style.setProperty("--table_font_color3", '#7889A0');
    document.documentElement.style.setProperty("--table_font_color4", '#333333');
    document.documentElement.style.setProperty("--table_bg_color", '#F8FCFF');
  }else if(style == 'black'){
    document.documentElement.style.setProperty("--main_color", '#1E2538');
    document.documentElement.style.setProperty("--bg_color", '#252B41');
    document.documentElement.style.setProperty("--bg2_color", '#1E2538');
    document.documentElement.style.setProperty("--active_color", '#5051F9');
    document.documentElement.style.setProperty("--button_color", '#5051F9');
    document.documentElement.style.setProperty("--font_color1", '#CECECE');
    document.documentElement.style.setProperty("--font_color2", '#FFFFFF');
    document.documentElement.style.setProperty("--buttonBg_color", '#2C344B');
    document.documentElement.style.setProperty("--buttonBorder_color", '#3F4867');
    document.documentElement.style.setProperty("--table_color1", '#2C344B');
    document.documentElement.style.setProperty("--table_color2", '#2C344B');
    document.documentElement.style.setProperty("--table_color3", '#6E7794');
    document.documentElement.style.setProperty("--table_color4", '#3F4867');
    document.documentElement.style.setProperty("--table_font_color1", '#CECECE');
    document.documentElement.style.setProperty("--table_font_color2", '#FFFFFF');
    document.documentElement.style.setProperty("--table_font_color3", '#2C344B');
    document.documentElement.style.setProperty("--table_font_color4", '#CECECE');
    document.documentElement.style.setProperty("--table_bg_color", '#4E587B');
  }
}


return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_el_menu, {
          "default-active": _ctx.$route.path,
          class: "el-menu-demo",
          "text-color": "#C7D2FF",
          "active-text-color": "#FFFFFF",
          mode: "horizontal",
          onSelect: goto
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(obj).navList, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_menu_item, {
                index: item.path,
                key: index
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1032, ["index"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["default-active"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_dropdown, { class: "changeStyle" }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  class: "el-dropdown-item",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (changeStyle('blue')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  class: "el-dropdown-item",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (changeStyle('red')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  class: "el-dropdown-item",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (changeStyle('black')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        (_unref(obj).userInfo)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(obj).userInfo.corp) + " | 账号：" + _toDisplayString(_unref(obj).userInfo.account), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, { onClick: logout }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})